// Modal Content, This content is mainly used for Modal wrap with MainModal.tsx Component
import React from "react";
import { InputField } from './InputField';
import google from "../assets/icons/google.svg";
import apple from "../assets/icons/apple.svg";
import face from "../assets/icons/fb.svg";
import linkedin from "../assets/icons/in.svg";
import PrimaryButton from './PrimaryButton';
import AccountGroupCard from "./AccountGroupCard";
import { ActionBothProps, ActionNextProps } from "../types/common";

export const ChooseGroup = ({ showPrev, showNext }: ActionBothProps) => {
  return (
    <>
      <h1 className="text-[#0F0C18] text-[24px] font-semibold tracking-tight mt-1">Choose group</h1>
      <p className="text-[#9392A2] text-sm font-medium leading-snug tracking-normal">Create new group or select existing one.</p>
      <p className="text-[#9392A2] text-xs mt-4 mb-3 font-medium tracking-tight">Create new account group</p>
      <InputField label="Enter account group name" />
      <PrimaryButton className="py-2.5 rounded-3xl w-full mt-3" label="Create account group" black />
      <p className="text-[#9392A2] text-xs mt-6 mb-3 font-medium tracking-tight">Select from the exisitng</p>
      <AccountGroupCard check className="w-full mb-2" />
      <AccountGroupCard check className="w-full" />
      <div className="flex items-center gap-2 mt-1">
        <PrimaryButton onClick={() => showPrev && showPrev()} className="py-2.5 rounded-3xl w-full mt-3" label="back" black />
        <PrimaryButton onClick={() => showNext && showNext()} className="py-2.5 rounded-3xl w-full mt-3" label="Confirm" />
      </div>
    </>
  );
};
const AddAccount = ({ showNext }: ActionNextProps) => {
  return (
    <>
      <h1 className="text-[#0F0C18] text-[24px] font-semibold tracking-tight mt-1">Add account</h1>
      <p className="text-[#9392A2] text-sm font-medium leading-snug tracking-normal mt-1">Connect your account by selecting <br />correct social network.</p>
      <p className="text-[#9392A2] text-xs mt-6 mb-3 font-medium tracking-tight">Continue with social network</p>
      <div className="bg-white text-center rounded-3xl py-3 relative mb-2 cursor-pointer">
        <img
          src={google}
          alt="google"
          className="absolute left-3"
        />
        <p className="text-base font-medium text-[#0F0C18]">
          Continue with Google
        </p>
      </div>
      <div className="bg-white text-center rounded-3xl py-3 relative mb-2 cursor-pointer">
        <img
          src={apple}
          alt="google"
          className="absolute left-3"
        />
        <p className="text-base font-medium text-[#0F0C18]">
          Continue with Apple
        </p>
      </div>
      <div className="bg-white text-center rounded-3xl py-3 relative mb-2 cursor-pointer">
        <img src={face} alt="google" className="absolute left-3" />
        <p className="text-base font-medium text-[#0F0C18]">
          Continue with Facebook
        </p>
      </div>
      <div className="bg-white text-center rounded-3xl py-3 relative mb-2 cursor-pointer">
        <img src={linkedin} alt="google" className="absolute w-6 h-6 left-3" />
        <p className="text-base font-medium text-[#0F0C18]">
          Continue with Facebook
        </p>
      </div>
      <p className="text-[#9392A2] text-xs mt-6 mb-3 font-medium tracking-tight">Connect read-only profile</p>
      <InputField label="Paste a link" />
      <PrimaryButton onClick={() => showNext && showNext()} className="py-2.5 rounded-3xl w-full mt-3" label="Add account" black />
    </>
  );
};

export default AddAccount;